/**
 * wireMatchOutcome — Sync nexus victory latch + debug hooks (P3-05/P3-15).
 * Presentation only: no combat formulas.
 */
export function wireMatchOutcome({ matchRuntime, onEnded } = {}) {
  function sync() {
    if (!matchRuntime || typeof matchRuntime.syncOutcome !== 'function') {
      return { ended: false, winnerTeam: null, loserTeam: null, destroyedNexusId: null };
    }
    const wasEnded = typeof matchRuntime.isMatchEnded === 'function'
      ? matchRuntime.isMatchEnded()
      : !!matchRuntime.outcome?.ended;
    const outcome = matchRuntime.syncOutcome();
    if (outcome.ended && !wasEnded && typeof onEnded === 'function') {
      onEnded(outcome);
    }
    return outcome;
  }

  function getOutcome() {
    return matchRuntime?.outcome || {
      ended: false,
      winnerTeam: null,
      loserTeam: null,
      destroyedNexusId: null
    };
  }

  if (typeof window !== 'undefined') {
    window.__debugGetMatchOutcome = getOutcome;
    window.__debugSyncMatchOutcome = sync;
  }

  return { sync, getOutcome };
}
